<template>
  <div class="metal-place">
    <div class="table-container">
      <form method="post" @submit.prevent="createMetalPlace()">
        
        <table id="create_table">
          <caption class="table-naming">Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }}</caption>
          <thead>
          <th class="metall-left-in-stock-sub-botm" scope="col">Место хранения</th>
          <th class="metall-left-in-stock-sub-botm" scope="col">Вид металла</th>
          <th class="metall-left-in-stock-sub-botm" scope="col">Отстаток металла</th>
          </thead>
          <tbody>
          <tr v-for="(item, index) in inputParam" :key="index">
            <th>
              <select class="metall-table-input" v-model="inputParam[index].place" required>
                <option value="">Выберите место хранения</option>
                <option v-for="place in catalog_places" :key="place.id" :value="place.id">{{ place.get_full_name }}
                </option>
              </select>
            </th>
            <th>
              <select class="metall-table-input" v-model="inputParam[index].metal_category" required>
                <option value="">Выберите тип металла</option>
                <option v-for="(req_item, req_type) in requests" :key="req_type"
                        :value="req_type">
                  {{ req_type }}
                </option>
              </select>
            </th>
            <td class="metall-info-contract-cell">
              <input class="metall-table-input" type="number" step="0.01" min="0" required
                     v-model="inputParam[index].count_after">
            </td>
          </tr>
          </tbody>
        </table>
        <div class="form-btn-actions">
          <button type="button" @click="addRow()"><i class="material-icons" aria-hidden="true">add</i>
        </button>
        <button v-if="inputParam.length > 0" type="button" @click="deleteRow()"
        ><i class="material-icons" aria-hidden="true">remove</i>
        </button>
        </div>
        <div class="form-btn">
          <button class="table-actions-button btn-green" type="submit">
          Сохранить
        </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CreateMetalPlace",
  data() {
    return {
      inputParam: [],
      catalog_places: [],
      requests: []
    }
  },
  methods: {
    createMetalPlace() {
      let tmp = JSON.parse(JSON.stringify(this.requests));
      for (let i = 0; i < this.inputParam.length; ++i) {
        if (this.inputParam[i].metal_category !== '' && this.inputParam[i].count_after !== '' && this.inputParam[i].place !== '') {
          if (tmp[this.inputParam[i].metal_category]) {
            this.inputParam[i].request_id = tmp[this.inputParam[i].metal_category][1]
            tmp[this.inputParam[i].metal_category][0] = (tmp[this.inputParam[i].metal_category][0] - this.inputParam[i].count_after).toFixed(2);
          }
        }
      }
      let flag = true;
      let alert_list = [];
      Object.keys(tmp).forEach(function (key) {
        if (tmp[key][0] !== (0).toFixed(2)) {
          flag = false;
          alert_list.push('Вид металла: ' + key + ' переполнен(-)/незаполнен(+): ' + tmp[key][0]);
        }
      });
      for (let i = 0; i < alert_list.length; ++i) {
        this.$store.dispatch("addNotification", {
          type: "error",
          message: alert_list[i],
        });
      }
      if (flag) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: 'Все ок',
        });
        const formData = {
          inputData: this.inputParam,
          report_id: this.$route.params.id,
        }
        this.$store.dispatch("createMetalPlace", formData);
      }
    },
    addRow() {
      let newInputObject = {
        place: '',
        metal_category: '',
        count_after: '',
        request_id: ''
      }
      this.inputParam.push(newInputObject);
    },
    deleteRow() {
      if (this.inputParam.length > 0) {
        this.inputParam.pop();
      }
    },
    getPlaceStartData() {
      this.$store.dispatch('getPlaceStartData', this.$route.params.id).then((response) => {
        this.catalog_places = response.placeCatalogs;
        this.requests = response.requests;
      });
    },
    getReport() {
      this.$store.dispatch('getReport', this.$route.params.id);
    },
  },
  mounted() {
    this.getReport();
    this.getPlaceStartData();
  },
  computed: {
    ...
        mapGetters([
          'REPORT',
          'USER'
        ]),
  },

}
</script>


<style scoped>
.metal-place {
  padding-top: 2rem;
}

.duplicate {
  background-color: #717171 !important;
}

.table-container {
  overflow-x: auto;
  padding: 0 2rem;
  /* max-width: 1800px; */
  margin: 0 auto;
}

.table-title {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 3rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

th, td {
  border: 1px solid #868686;
  height: 30px;
  /* padding-left: ; */
}

.table-specs {
  background: #36429E;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.tr-fixed-height {
  height: 100px;
}

.t-metall-type {
  height: 296px;
  width: 120px;
}

.t-metall-sub-type {
  width: 130px;
  height: 60px;
}

.metall-left-in-stock-botm,
.metall-left-in-stock-eotm {
  width: 180px;
  height: 75px;
}

.metall-left-in-stock-sub-botm,
.metall-left-in-stock-sub-eotm {
  width: 90px;
  height: 50px;
}

.metall-received {
  position: relative;
  width: 120px;
}

.metall-information,
.metall-notes {
  position: relative;
}

.table-column-hide {
  /* opacity: 0; */
  /* visibility: hidden; */
  /* appearance: none; */
  display: none;
  /* visibility: collapse; */
}

.table-column-show {
  opacity: 1;
}

.hide-btn,
.show-btn {
  position: absolute;
  top: 0;
  right: 12px;
  padding: .5rem;
  background: none;
  border: none;
}

.hide-btn:focus,
.show-btn:focus {
  outline: none;
}

.hide-btn i::before,
.show-btn i::before {
  font-size: 1.2rem;
}

.metall-info-sub-count {
  width: 120px;
}

.metall-info-sub-realization {
  width: 120px;
}

.metall-info-sub-payment {
  width: 90px;
}

.metall-info-sub-naming {
  width: 120px;
}

.metall-info-sub-bin {
  width: 120px;
}

.metall-info-sub-contract-number {
  width: 120px;
}

.metall-info-sub-date {
  width: 110px;
}

.metall-info-sub-price {
  width: 140px;
}

.metall-info-sub-sum {
  width: 140px;
}

.metall-info-sub-exported {
  width: 140px;
}

.metall-info-sub-left {
  width: 140px;
}


/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
  position: relative;
  /* width: 100px; */
  /* height: 75px; */
  display: none;
  border: none;
  /* border-bottom: 1px solid #868686; */
  margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
  line-height: 75px;
}

.metall-slot-hidden-notes.top-element {
  border-top: 1px solid black;
}

.metall-table-input {
  width: 100%;
  height: 100%;
  text-align: center;
}


.categories-top-actions {
  margin: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7AD38D;
  color: white;
}

.btn-blue {
  background: #36429E;
  color: white;
}

.total_calculate {
  background: rgba(89, 36, 36, 0.27);
}

/* .excel {
  float: right;
  border: grey 1px solid;
  border-radius: 5px;
  display: inline-block;
} */

.file-area {
  width: 100%;
  position: relative;
}

.file-area input[type=file] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  border-radius: 25px;
}

.file-area .file-state {
  width: 100%;
  padding: 1rem 1rem;


  border-radius: 10px;
  /* margin-left: 1rem; */
  cursor: pointer;
  font-size: 1.1rem;

  background: #5769F8;
  color: #fff;
  text-align: center;
  transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
  display: none;
}

.file-area:hover .file-state {
  background: rgba(255, 255, 255, 0.1);
  color: black !important;
}

.report-table-s {
  height: 100%;
  border: none;
  font-size: .8rem;
  background: none;
  /* text-align: center; */
  margin: 0 auto;
  /* width: 50px !important; */
}

.report-table-s2 {
  height: 100%;
  border: none;
  font-size: .8rem;
  background: none;
}

.file-area input[type=file]:focus + .file-state {
  /* outline: 2px solid rgba(255, 255, 255, 0.5); */
  /* outline: -webkit-focus-ring-color auto 5px; */
}

.custom-th-with-border {
  border: 1px solid #868686;
  background-color: red;
}

/* .file-area input[type=file]:valid+.file-state {
    border-color: #36B300;
    background-color: #36B300;
} */

.file-state-uploaded {
  border-color: #36B300;
  background-color: #36B300;
}

/* .file-area input[type=file]:valid+.file-state .success {
    display: inline-block;
}


.file-area input[type=file]:valid+.file-state .default {
    display: none;
} */

.form-btn {
  display: flex;
  justify-content: center;
  padding-top: 2rem;
}

.form-btn-actions {
  display: flex;
  justify-content: center;
}

</style>